<h2 mat-dialog-title class="title">{{ exercise.name }}</h2>
<mat-dialog-content class="mat-typography content">
  @if (exercise.instructions?.length) {
    <section
      class="instructions-section"
      >
      @for (instruction of exercise.instructions; track instruction; let i = $index) {
        <p>
          {{ i + 1 }}. {{ instruction }}
        </p>
      }
    </section>
  } @else {
    <p>Unfortunately, there are no instructions available for this exercise.</p>
  }
</mat-dialog-content>
<mat-dialog-actions class="actions" align="end">
  <button
    mat-dialog-close
    mat-stroked-button
    cdkFocusInitial
    ftE2e="closeExerciseDetailsDialog"
    >
    Close
  </button>
</mat-dialog-actions>

